"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';


const Intro = () => {
    return (
        <div>
            <section className=" bg-white py-10 md:py-20 lg:py-24">
                <div className="max-w-screen-xl mx-5 lg:mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 items-start justify-between text-center mb-6 md:mb-10">
                        <div>
                            <a href="/gallery/"><img src="/images/vfx_gallery1.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/vfx_gallery2.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/vfx_gallery3.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/vfx_gallery4.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/vfx_gallery5.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-3 md:gap-6 items-start justify-between">
                        <p>At 3Pop Studios, VFX and Motion Graphics are an integral part of our services. Video content comes with its share of endless scope for graphics and techniques. Our design teams add a different level of production value to your projects.</p>
                        <p>Covering a large range of needs for your film, commercial and television productions, we explore and conceptualize any ideas you have. Enabled with the skills and multiple tools to create visual elements, we strive at achieving what seems impossible.</p>
                        <p className="font-bold mb-0">Our Services:</p>
                        <ul className="list-disc ml-4 mb-4">
                            <li>Roto</li>
                            <li>Paint</li>
                            <li>Match Move</li>
                            <li>Rendering</li>
                            <li>Compositing</li>
                        </ul>
                    </div>                    
                </div>
            </section>
        </div>
    );
};

export default Intro;